import React from 'react';
import { Row } from '../../grid/Row/Row';
import { Input } from '../Input/Input';
import { Select } from '../Select/Select';
import { ContentVideoLayout } from '../../../../_blocks/VideoBlock/VideoBlock.types';
import { Option } from '../Select/Option';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { TextParam } from '../../types/TextParam';
import { SelectParam } from '../../types/SelectParam';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

export type VideoFormTemplateParams = {
  title?: TextParam<'title'>;
  source: TextParam<'source'>;
  caption?: TextParam<'caption'>;
  selectLayout?: SelectParam<'layout', { value: ContentVideoLayout }>;
  captionsFile: TextParam<'captionsFile'>;
  copyright: TextParam<'copyright'>;
};

export function VideoFormTemplate({
  title,
  source,
  caption,
  selectLayout,
  captionsFile,
  copyright,
}: VideoFormTemplateParams) {
  const { t } = useSonTranslation('VideoUpload');

  return (
    <>
      { title
        ? (
            <Row>
              <Input label={t('title')} param={title} />
            </Row>
          )
        : null }
      <Row>
        <Input
          label={t('source')}
          helpText={t('sourceHelpText')}
          tooltipPlacement={TooltipPlacement.TOP}
          param={source}
        />
      </Row>
      { caption
        ? (
            <Row>
              <Input label={t('caption')} param={caption} />
            </Row>
          )
        : null }
      { selectLayout
        ? (
            <Row>
              <Select label={t('layout')} param={selectLayout}>
                {selectLayout.options.map((option: { value: ContentVideoLayout }) => (
                  <Option key={option.value} value={option.value}>
                    {t(`inputs.layout.options.${option.value}`)}
                  </Option>
                ))}
              </Select>
            </Row>
          )
        : null }
      <Row>
        <Input
          label={t('captionsFile')}
          helpText={t('captionsFileHelpText')}
          tooltipPlacement={TooltipPlacement.TOP}
          param={captionsFile}
        />
      </Row>
      <Row>
        <Input
          label={t('copyright')}
          helpText={t('videoCopyrightHelpText')}
          tooltipPlacement={TooltipPlacement.TOP}
          param={copyright}
        />
      </Row>
    </>
  );
}
